import createIcon from '../../createIcon';

/**
 * @component @name AddLocationAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguNSAxVjRIMjEuNVY2SDE4LjVWOUgxNi41VjZIMTMuNVY0SDE2LjVWMUgxOC41Wk0xMC41IDEzQzExLjYgMTMgMTIuNSAxMi4xIDEyLjUgMTFDMTIuNSA5LjkgMTEuNiA5IDEwLjUgOUM5LjQgOSA4LjUgOS45IDguNSAxMUM4LjUgMTIuMSA5LjQgMTMgMTAuNSAxM1pNMTIuNSAzLjI1VjdIMTUuNVYxMEgxOC40MkMxOC40NyAxMC4zOSAxOC41IDEwLjc5IDE4LjUgMTEuMkMxOC41IDE0LjUyIDE1LjgzIDE4LjQ1IDEwLjUgMjNDNS4xNyAxOC40NSAyLjUgMTQuNTIgMi41IDExLjJDMi41IDYuMjIgNi4zIDMgMTAuNSAzQzExLjE4IDMgMTEuODUgMy4wOCAxMi41IDMuMjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AddLocationAlt = createIcon('AddLocationAlt', [
  [
    'path',
    {
      d: 'M18.5 1V4H21.5V6H18.5V9H16.5V6H13.5V4H16.5V1H18.5ZM10.5 13C11.6 13 12.5 12.1 12.5 11C12.5 9.9 11.6 9 10.5 9C9.4 9 8.5 9.9 8.5 11C8.5 12.1 9.4 13 10.5 13ZM12.5 3.25V7H15.5V10H18.42C18.47 10.39 18.5 10.79 18.5 11.2C18.5 14.52 15.83 18.45 10.5 23C5.17 18.45 2.5 14.52 2.5 11.2C2.5 6.22 6.3 3 10.5 3C11.18 3 11.85 3.08 12.5 3.25Z',
      key: 'ovk2pp',
    },
  ],
]);

export default AddLocationAlt;
